export const CALENDAR_COLORS_STORAGE_KEY = "hrmsCalendarColorSettings";
export const CALENDAR_COLORS_STORAGE_EVENT = "hrms-calendar-colors-updated";

export const DEFAULT_CALENDAR_COLORS = {
  Title: "#6d28d9",
  Meeting: "#7e22ce",
  Event: "#1d4ed8",
  Holiday: "#c21845",
  "Leave - Approved": "#15803d",
  "Leave - Pending": "#5b660a",
  "Leave - Cancelled": "#d97706",
  "Leave - Declined": "#881337",
  "Leave - Unapproved": "#dc2626",
  Birthday: "#be185d",
};

export const getCalendarColorSettings = () => {
  try {
    const stored = window.localStorage.getItem(CALENDAR_COLORS_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return { ...DEFAULT_CALENDAR_COLORS, ...parsed };
    }
  } catch (e) {
    console.error("Error reading calendar color settings:", e);
  }
  return { ...DEFAULT_CALENDAR_COLORS };
};

export const saveCalendarColorSettings = (colors) => {
  try {
    const nextColors = { ...DEFAULT_CALENDAR_COLORS, ...colors };
    window.localStorage.setItem(CALENDAR_COLORS_STORAGE_KEY, JSON.stringify(nextColors));
    window.dispatchEvent(new CustomEvent(CALENDAR_COLORS_STORAGE_EVENT, { detail: nextColors }));
    return nextColors;
  } catch (e) {
    console.error("Error saving calendar color settings:", e);
  }
  return colors;
};
